import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import { Badge, Box, ButtonBase, Typography } from '@mui/material';

import PhoneNumberVerificationContainer from '../FrontDesk/Softphone/PhoneNumberVerificationContainer';

import ModalHandlerComponent from '../Modal/ModalHandlerComponent';
import PhoneNumber from './PhoneNumberComponent';

import { getPropertySettings } from '../BuildingSettings/actions/propertySettingsActions';

import usePrevious from '../../hooks/usePrevious';
import InfoComponent from '../Info';
import { CUSTOM } from '../Modal/modalTypes';

const PhoneNumberWithVerification = (props) => {
  const dispatch = useDispatch();

  const { verificationStatus, input, meta, buildingId } = props;

  const [isVerificationModalShown, setIsVerificationModalShown] =
    useState(false);

  const isVerificationModalShownPrev = usePrevious(isVerificationModalShown);

  useEffect(() => {
    if (isVerificationModalShownPrev && !isVerificationModalShown) {
      getPropertySettings(dispatch, buildingId);
    }
  }, [isVerificationModalShown]);

  const isVerified = verificationStatus === 'success';

  const initialPhoneNumber = meta?.initial;
  const phoneNumber = input?.value;
  const isValidated = initialPhoneNumber === phoneNumber;

  return (
    <>
      <Box width="100%" display="flex" alignItems="center">
        <Box width="65%" pr="2rem">
          <PhoneNumber {...props} placeholder="Phone" />
        </Box>
        {Boolean(phoneNumber) && (
          <Box width="35%" display="flex" alignItems="center">
            <Badge
              variant="dot"
              badgeContent=""
              color={isVerified && isValidated ? 'success' : 'secondary'}
              sx={{ marginRight: '1rem' }}
            />
            <Typography fontSize="1.4rem" lineHeight="1">
              {isVerified && isValidated ? (
                'Phone number verified'
              ) : isValidated ? (
                <ButtonBase
                  onClick={() => setIsVerificationModalShown(true)}
                  sx={{ textAlign: 'left' }}
                  disableRipple
                  disableTouchRipple
                >
                  Verify phone number
                </ButtonBase>
              ) : (
                'Submit changes to verify'
              )}
            </Typography>
          </Box>
        )}
      </Box>
      <Box mt="1rem">
        <InfoComponent>
          <Typography fontWeight="bold">Instructions:</Typography>
          <Typography>
            1. Add the phone number to the field above and submit changes below.
          </Typography>
          <Typography>
            2. Click the red &quot;Verify phone number&quot; to receive the
            verification code. This will initiate a call to the phone number
            being verified.
          </Typography>
          <Typography>
            3. Provide the validation code to the user who is trying to verify
            their phone number. (This may be a client on site).
          </Typography>
        </InfoComponent>
      </Box>
      {isVerificationModalShown && (
        <ModalHandlerComponent
          modal={{
            modalType: CUSTOM,
            modalProps: {
              title: 'validation code',
            },
          }}
          onModalClose={() => setIsVerificationModalShown(false)}
        >
          <PhoneNumberVerificationContainer
            phoneNumber={phoneNumber}
            buildingId={buildingId}
            onModalClose={() => setIsVerificationModalShown(false)}
          />
        </ModalHandlerComponent>
      )}
    </>
  );
};

PhoneNumberWithVerification.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  buildingId: PropTypes.string.isRequired,
  verificationStatus: PropTypes.string,
};

export default PhoneNumberWithVerification;
